import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BridgeClientError } from '..';
export var createExtensionPathParsers = function createExtensionPathParsers(extensionBasePath) {
  return {
    extensionRouteToFullPath: function extensionRouteToFullPath(extensionRoute) {
      return "".concat(extensionBasePath).concat(extensionRoute !== null && extensionRoute !== void 0 ? extensionRoute : '');
    },
    fullPathToExtensionRoute: function fullPathToExtensionRoute(fullLocation) {
      var extensionRoute = fullLocation.split(extensionBasePath).pop();
      return extensionRoute ? extensionRoute : '/';
    }
  };
};
export var createHistory = function createHistory(_ref) {
  var history = _ref.history,
    extensionBasePath = _ref.extensionBasePath;
  if (!history || !extensionBasePath) {
    throw new BridgeClientError('History API is not available within this module.');
  }
  var _createExtensionPathP = createExtensionPathParsers(extensionBasePath),
    extensionRouteToFullPath = _createExtensionPathP.extensionRouteToFullPath,
    fullPathToExtensionRoute = _createExtensionPathP.fullPathToExtensionRoute;
  var parseLocation = function parseLocation(location, parser) {
    return _objectSpread(_objectSpread({}, location), {}, {
      pathname: parser(location.pathname)
    });
  };
  var setNewHistoryLocation = function setNewHistoryLocation(type, pathOrLocation, state) {
    var setHistory = type === 'push' ? history.push : history.replace;
    if (typeof pathOrLocation === 'string') {
      return setHistory(extensionRouteToFullPath(pathOrLocation), state);
    }
    return setHistory(parseLocation(_objectSpread({
      state: state
    }, pathOrLocation), extensionRouteToFullPath));
  };
  return _objectSpread(_objectSpread({}, history), {}, {
    location: parseLocation(history.location, fullPathToExtensionRoute),
    push: function push(pathOrLocation, state) {
      setNewHistoryLocation('push', pathOrLocation, state);
    },
    replace: function replace(pathOrLocation, state) {
      setNewHistoryLocation('replace', pathOrLocation, state);
    },
    listen: function listen(listener) {
      var unlisten = history.listen(function (location, action) {
        listener(parseLocation(location, fullPathToExtensionRoute), action);
      });
      return unlisten;
    }
  });
};